import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {jsonapiModule} from 'jsonapi-vuex/src/jsonapi-vuex.js'


Vue.use(Vuex)

const api = axios.create({
    baseURL: 'https://cv-api.dita1.fhk-app.com/cv/api/v2/',
    headers: {
        'Content-Type': 'application/vnd.api+json',
    },
})

export default new Vuex.Store({
    state: {
        user: {} as any,
        staffId: null,
        isAdmin: false,
    },
    mutations: {
        async addUser(store, payload) {
            store.user = payload
        },
        addStaffId(store, payload) {
            store.staffId = payload
        },
        updateAdmin(store) {
            store.isAdmin = true
        }
    },
    actions: {
        async addStaffId(store) {
            const staffId = await store.dispatch('jv/get', ['staffs', {
                params: {'filter[email][eq]': store.state.user.mail}
            }])
            if (Object.keys(staffId).length === 1) store.commit('addStaffId', Object.keys(staffId)[0])
        }
    },
    modules: {
        jv: jsonapiModule(api)
    }
})
